module.exports = __webpack_public_path__ + "images/psp/ATV/car-storage-guide.jpg";